import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, withCtx as _withCtx, Fragment as _Fragment, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "colCenter marg-s"
}
const _hoisted_2 = { class: "row w-full gap-10" }
const _hoisted_3 = {
  for: "address",
  class: "col-0-8 main-m font-m align-r"
}
const _hoisted_4 = { class: "row w-full gap-10 mtop-10" }
const _hoisted_5 = {
  for: "badge",
  class: "col-0-8 main-m font-m align-r"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = ["data-invalid"]
const _hoisted_8 = {
  for: "name",
  class: "waiting-room-form__field-label col-0-8 main-m font-m align-r"
}
const _hoisted_9 = {
  key: 0,
  class: "main-alert font-size-14 waiting-room-form__field-error"
}
const _hoisted_10 = { class: "row w-full gap-10 mtop-10" }
const _hoisted_11 = {
  for: "is-default",
  name: "is-default",
  class: "col-0-8 main-m font-m align-r"
}

import { ref, computed, watch } from "vue";
import { useI18n } from "vue-i18n";
import { type WaitingRoom, type WaitingRoomForm } from "@/models/institute.model";
import { InstituteAddress, InstituteApi, InstituteRoomBadge, InstituteRoomBadgeApi } from "@/apiGenerate/medserver";
import { medServerApiConfig } from "@/config/medserver-api.config";
import EsModal from '@/components/modals/esModal.vue';
import { Checkbox, InputText, Select, SelectButton } from "primevue";
import esWaitingRoomBadge from "@/components/esWaitingRoomBadge.vue"
import loadingSpinner from "@/views/loadingSpinner.vue";
import { NO_BADGE } from "@/models/calendar.model";


export default /*@__PURE__*/_defineComponent({
  __name: 'esWaitingRoomForm',
  props: {
    isOpen: { type: Boolean },
    header: {},
    waitingRoom: {},
    currInstituteUUID: {},
    onConfirm: { type: Function }
  },
  emits: ["modal-close"],
  setup(__props: any, { emit: __emit }) {

const instituteApi = new InstituteApi(medServerApiConfig);
const roomBadgeApi = new InstituteRoomBadgeApi(medServerApiConfig);

const props = __props;

const emit = __emit;
const { t } = useI18n();
const isEditing = computed(() => !!props.waitingRoom?.roomId);
const selectedAddressId = ref<string | null>(null);
const selectedRoomBadgeId = ref<string>(NO_BADGE);
const addresses = ref<InstituteAddress[]>([]);
const roomBadges = ref<InstituteRoomBadge[]>([]);
const nameSubmitError = ref<boolean>(false);
const isLoading = ref<boolean>(true);

const localWaitingRoom = ref<WaitingRoom>({
  roomId: "",
  name: "",
  street: "",
  byDefault: false,
  addressId: "",
  instituteId: "",
  roomBadgeId: null,
});

const addressesOptions = computed(() => addresses.value.map(({ address, addressId }) => ({
  id: addressId,
  label: address.street
})));

const noRoomBadgeOption = { uuid: NO_BADGE, text: t('settings.label.waitingRoom.noBadge'), color: null as null };
const roomBadgeOptions = computed(() => [noRoomBadgeOption, ...roomBadges.value]);

watch (() => props.isOpen, async (isOpen) => {
  if (!isOpen) return;
  nameSubmitError.value = false;
  isLoading.value = true;

  if (isEditing.value && props.waitingRoom) {
    localWaitingRoom.value = { ...props.waitingRoom };
    selectedAddressId.value = props.waitingRoom.addressId || "";
    selectedRoomBadgeId.value = props.waitingRoom.roomBadge?.uuid || NO_BADGE;
  } else {
    localWaitingRoom.value = {
      roomId: "",
      name: "",
      street: "",
      byDefault: false,
      addressId: null,
      instituteId: "",
      roomBadgeId: null,
    };
    selectedRoomBadgeId.value = NO_BADGE;
    selectedAddressId.value = "";
  }

  try {
    await getAllAddresses();
    await getAllBadges();

    if (!isEditing.value && addresses.value.length > 0) {
      selectedAddressId.value = addresses.value[0].addressId;
    }
  } finally {
    isLoading.value = false;
  }
});

const isNameValid = computed(() => localWaitingRoom.value.name.trim().length > 0);

const onClose = () => {
  emit("modal-close");
}

const onConfirm = () => {
  if (isNameValid.value) {
    props.onConfirm({
      roomId: localWaitingRoom.value.roomId || "",
      addressId: selectedAddressId.value,
      name: localWaitingRoom.value.name,
      byDefault: localWaitingRoom.value.byDefault,
      isEditing: isEditing.value,
      roomBadgeId: selectedRoomBadgeId.value === NO_BADGE ? null : selectedRoomBadgeId.value,
    });
  } else {
    nameSubmitError.value = true;
    throw t('settings.label.waitingRoom.nameRequired');
  }
};

const getAllAddresses = async () => {
  await instituteApi.listAddressesByInstitute({ instituteId: props.currInstituteUUID }).then((res: InstituteAddress[]) => {
    addresses.value = res;
  })
};

const getAllBadges = async () => {
  await roomBadgeApi.listInstituteRoomBadge().then((res: InstituteRoomBadge[]) => {
    roomBadges.value = res;
  })
}

return (_ctx: any,_cache: any) => {
  const _component_es_modal_footer = _resolveComponent("es-modal-footer")!

  return (_openBlock(), _createBlock(EsModal, {
    title: props.header,
    "is-open": props.isOpen
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_es_modal_footer, {
        onModalCancel: onClose,
        confirmModalMethod: onConfirm
      })
    ]),
    default: _withCtx(() => [
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(loadingSpinner, {
              logo: false,
              style: 'w-3'
            })
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("label", _hoisted_3, [
                _createTextVNode(_toDisplayString(_unref(t)('settings.label.waitingRoom.address')), 1),
                _cache[4] || (_cache[4] = _createElementVNode("span", { class: "main-alert" }, "*", -1))
              ]),
              _createVNode(_unref(Select), {
                "label-id": "address",
                modelValue: selectedAddressId.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedAddressId).value = $event)),
                options: addressesOptions.value,
                "option-value": "id",
                "option-label": "label",
                size: "small",
                class: "w-full",
                "empty-message": _unref(t)('settings.label.waitingRoom.noAddress')
              }, null, 8, ["modelValue", "options", "empty-message"])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("label", _hoisted_5, _toDisplayString(_unref(t)('settings.label.waitingRoom.badge')), 1),
              _createVNode(_unref(SelectButton), {
                modelValue: selectedRoomBadgeId.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedRoomBadgeId).value = $event)),
                options: roomBadgeOptions.value,
                "option-value": (slotProps) => slotProps.uuid,
                "option-label": "text",
                "data-key": "uuid",
                "allow-empty": false
              }, {
                option: _withCtx((slotProps) => [
                  (slotProps.option.uuid !== _unref(NO_BADGE))
                    ? (_openBlock(), _createBlock(esWaitingRoomBadge, {
                        key: 0,
                        color: slotProps.option.color,
                        text: slotProps.option.text
                      }, null, 8, ["color", "text"]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(slotProps.option.text), 1))
                ]),
                _: 1
              }, 8, ["modelValue", "options", "option-value"])
            ]),
            _createElementVNode("div", {
              class: "w-full mtop-10 waiting-room-form__field",
              "data-invalid": nameSubmitError.value
            }, [
              _createElementVNode("label", _hoisted_8, [
                _createTextVNode(_toDisplayString(_unref(t)('settings.label.waitingRoom.name')), 1),
                _cache[5] || (_cache[5] = _createElementVNode("span", { class: "main-alert" }, "*", -1))
              ]),
              _createVNode(_unref(InputText), {
                type: "text",
                name: "name",
                id: "name",
                class: "waiting-room-form__field-input w-full",
                size: "small",
                modelValue: localWaitingRoom.value.name,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((localWaitingRoom.value.name) = $event)),
                invalid: nameSubmitError.value
              }, null, 8, ["modelValue", "invalid"]),
              (nameSubmitError.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_unref(t)('settings.label.waitingRoom.nameRequired')), 1))
                : _createCommentVNode("", true)
            ], 8, _hoisted_7),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("label", _hoisted_11, _toDisplayString(_unref(t)('settings.label.waitingRoom.byDefault')), 1),
              _createVNode(_unref(Checkbox), {
                modelValue: localWaitingRoom.value.byDefault,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((localWaitingRoom.value.byDefault) = $event)),
                binary: "",
                inputId: "is-default"
              }, null, 8, ["modelValue"])
            ])
          ], 64))
    ]),
    _: 1
  }, 8, ["title", "is-open"]))
}
}

})